const bundleEvalTimingsInternal = (_config, data, globalConfig, performance = window.performance) => {
  var _globalConfig$enableB;

  const started = {};
  const timings = {};
  const enableBundleEvalTimings = (_globalConfig$enableB = globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.enableBundleEvalTimings) !== null && _globalConfig$enableB !== void 0 ? _globalConfig$enableB : true;
  performance.getEntriesByType('mark').forEach(mark => {
    if (!globalConfig.bundleEvalTimings) {
      return;
    }

    const result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);

    if (!result) {
      return;
    }

    const {
      type,
      name
    } = result;

    if (type === 'start' && data.start !== null && mark.startTime >= data.start) {
      started[name] = mark;
      return;
    }

    if (type === 'end' && started[name]) {
      timings[name] = {
        startTime: Math.round(started[name].startTime - data.start),
        duration: Math.round(mark.startTime - started[name].startTime)
      };
      delete started[name];
    }
  });

  if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
    const result = globalConfig.bundleEvalTimings.additionalTimings(data.start);

    if (result) {
      Object.entries(result).forEach(([key, value]) => {
        timings[key] = value;
      });
    }
  }

  if (Object.keys(timings).length === 0) {
    return null;
  }

  return {
    'timings:bundleEval': timings
  };
};

export const bundleEvalTimings = (...args) => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(bundleEvalTimingsInternal(...args));
    });
  });
};